import React from "react";
import Model from "../Model";
import { SubmitBtn } from "../Styles/InputStyles";
import {
    FiCheck,
    FiDownload,
    FiExternalLink,
    FiFileText,
} from "react-icons/fi";

const ReportSuccessModal = ({
    setShowSuccessModal,
    generatedReportUrl,
    handleOpenReport,
    handleDownloadAndNavigate
}) => {
    return (
        <Model
            width="w-full max-w-lg"
            setOpenModel={setShowSuccessModal}
            title=""
        >
            <div className="relative overflow-hidden">

                {/* Top Success Section */}
                <div className="flex flex-col items-center text-center">

                    {/* Success Circle */}
                    <div className="relative mb-5">
                        <div className="absolute inset-0 rounded-full bg-emerald-100 blur-xl opacity-70" />

                        <div className="relative w-20 h-20 rounded-full bg-emerald-50 border-8 border-white shadow-sm flex items-center justify-center">
                            <div className="w-12 h-12 rounded-full bg-emerald-500 flex items-center justify-center shadow-lg shadow-emerald-200">
                                <FiCheck
                                    className="w-6 h-6 text-white"
                                    strokeWidth={3}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Heading */}
                    <h2 className="text-2xl font-bold text-gray-800 tracking-tight">
                        Report Generated!
                    </h2>

                    <p className="mt-2 text-sm text-gray-500 leading-6 max-w-sm">
                        Your report has been generated successfully and is
                        ready to view.
                    </p>
                </div>

                {/* Report Ready Card */}
                <div className="mt-7 rounded-xl border border-gray-200 bg-gray-50/70 p-4">
                    <div className="flex items-center gap-4">

                        <div className="w-11 h-11 shrink-0 rounded-xl bg-white border border-gray-200 shadow-sm flex items-center justify-center">
                            <FiFileText className="w-5 h-5 text-emerald-600" />
                        </div>

                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-semibold text-gray-800">
                                Your report is ready
                            </p>

                            <p className="text-xs text-gray-500 mt-1">
                                View it now or access it anytime from Downloads.
                            </p>
                        </div>

                        <div className="hidden sm:flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 border border-emerald-100">
                            {/* <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" /> */}
                            <span className="text-[11px] font-medium text-emerald-700">
                                Ready
                            </span>
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="mt-6 space-y-3">

                    {/* Primary Action */}
                    <SubmitBtn
                        type="button"
                        onClick={handleOpenReport}
                        className="
                            !m-0
                            !w-full
                                                      !flex
                            !items-center
                            !justify-center
                            gap-2.5
                            text-sm
                            font-semibold
                            shadow-sm
                            transition-all
                            hover:shadow-md
                        "
                    >
                        <FiExternalLink className="w-[17px] h-[17px]" />
                        Open Report
                    </SubmitBtn>

                    {/* Secondary Action */}
                    <button
                        type="button"
                        onClick={handleDownloadAndNavigate}
                        className="
                            w-full
                            h-12
                            rounded-md
                            border
                            border-gray-200
                            bg-white
                            text-gray-700
                            text-sm
                            font-semibold
                            flex
                            items-center
                            justify-center
                            gap-2.5
                            transition-all
                            hover:bg-gray-50
                            hover:border-gray-300
                            active:scale-[0.99]
                        "
                    >
                        <FiDownload className="w-[17px] h-[17px]" />
                        Download Report
                    </button>
                </div>

            </div>
        </Model>
    );
};

export default ReportSuccessModal;

